

<template>
    <div>  
    
        <div v-for="item in contactObjects" class="d-flex ContactRow" @click="IntoChat(item)">
            <div class="ContactRowImgDiv">
                <img class="ContactRowImg" src="../../assets/image/consultant_square.png" v-if="item.UserType =='CS'" />
                <img class="ContactRowImg" src="../../assets/image/service.png" v-if="item.UserType !='CS'" />
            </div>
            <span class="ContactRowId">ID:{{item.Users.UserId}}</span>
            <span class="ContactRowName">{{item.Users.UserName}}</span>
        </div>
    </div>
</template>

<script>
import {app} from '@/main'
import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'

export default {
    name: 'Contact',
    props: ['contactObjects'],
    components:{},
    data () {
        return {
            
        }
    },
    methods:{
        IntoChat(item){
            var data={
                MsgType: 1,                
                msgHistory: {
                    UserId: item.Users.UserId,
                    UserName: item.Users.UserName,
                }
            }

            this.$router.push({
                name: 'Chat',
                params: { 
                    msgObjects:data,
                }
            });
        },
    },
    created(){
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Pages/Contact.vue